import { format } from 'date-fns';

export const FORECAST_EXPORT_VERSION_DATE_FORMAT = 'dd-MM-yyyy_HH-mm';

/**
 * User-facing name of a demand-forecast export, without file ending. The date
 * segment is the forecast version's `createdAt` — the same value the
 * "Forecast Version" dropdown labels the version with — so a downloaded file
 * identifies the version it contains, not the moment it was exported.
 */
export function getForecastExportFileName(
  configurationName: string,
  forecastVersionCreatedAt: Date | string,
): string {
  const versionDate = format(
    new Date(forecastVersionCreatedAt),
    FORECAST_EXPORT_VERSION_DATE_FORMAT,
  );
  return `pacemaker_forecast_${configurationName.replaceAll(
    ' ',
    '_',
  )}_${versionDate}`;
}
